/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { ArtifactsControllerFindAllQueryResponse, ArtifactsControllerFindAllPathParams, ArtifactsControllerFindAllQueryParams, ArtifactsControllerFindAll401, ArtifactsControllerFindAll403 } from "../../models/documentArtifactsController/ArtifactsControllerFindAll";

function getArtifactsControllerFindAllUrl(documentId: ArtifactsControllerFindAllPathParams["documentId"], renditionId: ArtifactsControllerFindAllPathParams["renditionId"]) {
  const res = { method: 'GET', url: `/api/v1/documents/${documentId}/renditions/${renditionId}/artifacts` as const }  
  return res
}

/**
 * @description Returns artifacts with JSON:API pagination, sorting, and filtering
 * @summary List all artifacts for a specific rendition
 * {@link /api/v1/documents/:documentId/renditions/:renditionId/artifacts}
 */
export async function artifactsControllerFindAll(documentId: ArtifactsControllerFindAllPathParams["documentId"], renditionId: ArtifactsControllerFindAllPathParams["renditionId"], params?: ArtifactsControllerFindAllQueryParams, config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<ArtifactsControllerFindAllQueryResponse, ResponseErrorConfig<ArtifactsControllerFindAll401 | ArtifactsControllerFindAll403>, unknown>({ method : "GET", url : getArtifactsControllerFindAllUrl(documentId, renditionId).url.toString(), params, ... requestConfig })  
  return res.data
}